import React from "react"
import PropTypes from "prop-types"

const FeaturesTileText = ({ tileTitle }) => {
  if (tileTitle === "Find Sponsors") {
    return (
      <p className="is-size-6-mobile is-size-5-tablet is-size-5-widescreen">
        Check out our <strong>sponsorship companies list</strong>, a curated
        collection of companies looking to sponsor creators of all kinds.
      </p>
    )
  } else if (tileTitle === "Collect Tips") {
    return (
      <p className="is-size-6-mobile is-size-5-tablet is-size-5-widescreen">
        Collect tips for your stream, YouTube channel, podcast and more with our 
        {" "}<strong>free, sleek, personalized web pages</strong>.
      </p>
    )
  } else if (tileTitle === "Create Opportunities") {
    return (
      <p className="is-size-6-mobile is-size-5-tablet is-size-5-widescreen">
        Post your unique, custom sponsorship opportunities and{" "}
        <strong>accept payment right on our platform</strong>.
      </p>
    )
  }
}

FeaturesTileText.propTypes = {
  tileTitle: PropTypes.string.isRequired,
}

export default FeaturesTileText
